import { render } from "./App.vue?vue&type=template&id=d8ddd912"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d8ddd912&lang=scss"

import exportComponent from "C:\\Users\\tieke\\Documents\\Studieverenigingen\\SV Sticky\\Maatschappelijk karakter 2021-2022\\Goede doelen dag\\goede-doelen-dag\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__